module.exports = __webpack_public_path__ + "img/head_2.3b8b3d72.png";